import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page21({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Exercise 06 Dead Lift'
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'Stiff - Legged Dead Lifts',
						},
						{
							header: '# of sets',
							value: '1 - 2',
						},
						{
							header: 'REPS / Weight',
							value: '8 - 10 Mild - Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Working Set, Strict Form / Controlled',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Stiff - Legged Dead Lifts',
						},
						{
							header: '# of sets',
							value: '3',
						},
						{
							header: 'REPS / Weight',
							value: 'Mild - Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full on Set Till Failure',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
